import classNames from "classnames";
import React from "react";

import LoadingSpinner from "../../../common/LoadingSpinner";
import { ConfiguratorTypes } from "../../../constants";

interface IProps {
    configuratorType: ConfiguratorTypes;
    alternatePriceView?: boolean;
}

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to 32 LOC, simple presentational component with classNames styling, no state or lifecycle, minimal props.
export class ConfiguratorPriceLoading extends React.PureComponent<
    IProps,
    IState
> {
    render() {
        const priceClasses = classNames({
            "configurator__price": true,
            "configurator__price--loading": true,
            [`configurator__price--${this.props.configuratorType}`]: true,
            "configurator__price--alternate": this.props.alternatePriceView,
        });
        return (
            <div className={priceClasses}>
                <LoadingSpinner fadeIn="quarter" />
            </div>
        );
    }
}
